export default {
  styleMapping: 'secondaryButton',
  customSettings: {
    text: {
      fontSize: 14
    },
    spacing: {
      padding: {
        paddingTop: 5,
        paddingRight: 5,
        paddingBottom: 5,
        paddingLeft: 5
      }
    }
  }
};
